import React, { useState, useEffect } from "react";
import { auth, database } from "../components/firebaseCtx";
import { green, red, pink } from "../scripts/Misc";
import { update, remove, ref as dRef } from "firebase/database";
import { sendEmailVerification } from "firebase/auth";
import { encode } from "firebase-key";
import axios from "../scripts/axiosConfig";
import { toast } from "react-toastify";

import {
	signInWithEmailAndPassword,
	signInWithPopup,
	signInWithRedirect,
	createUserWithEmailAndPassword,
	updateProfile,
	setPersistence,
	GoogleAuthProvider,
	FacebookAuthProvider,
	GithubAuthProvider,
	signOut,
} from "firebase/auth";
import { set, ref, child, get, onValue, query, orderByChild, startAt, limitToFirst, equalTo } from "firebase/database";
import useArray from "../hooks/useArray";

export const AuthContext = React.createContext();

const GoogleProvider = new GoogleAuthProvider();
GoogleProvider.setCustomParameters({
	prompt: "select_account",
});

const FaceBookProvider = new FacebookAuthProvider();
FaceBookProvider.setCustomParameters({
	prompt: "select_account",
});

const GithubProvider = new GithubAuthProvider();
GithubProvider.setCustomParameters({
	prompt: "select_account",
});

export const useAuth = () => {
	return React.useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
	const [currentUser, setCurrentUser] = useState(null);
	const [signupInProgress, setSignupInProgress] = useState(false);
	const [userJson, setUserJson] = useState(null);
	const [author] = useState("Sabz");

	const SET_USER = (user) => {
		console.trace("SET_USER called from children");
		setCurrentUser(user);
	};

	const GET_USER = () => {
		return currentUser;
	};

	const USER_PRESENT = () => {
		if (currentUser === "none" || !currentUser) return false;
		else if (currentUser) return true;
	};

	const USER_LOADING = () => {
		if (currentUser === null) return true;
		return false;
	}

	const SIGN_IN_WITH_EMAIL = (email, password) => {
		return signInWithEmailAndPassword(auth, email, password);
	};

	const signinwithpopup = (provider) => {
		console.log("sign in with");
		if (provider === "GOOGLE") {
			console.log("logging with google");
			return signInWithPopup(auth, GoogleProvider);
		} else if (provider === "FACEBOOK") {
			console.log("logging with facebook");
			return signInWithPopup(auth, FaceBookProvider);
		} else if (provider === "GITHUB") {
			console.log("logging with gh");
			return signInWithPopup(auth, GithubProvider);
		}
	};

	const signinwithredirect = (provider) => {
		if (provider === "google") {
			return signInWithRedirect(auth, GoogleProvider);
		} else if (provider === "facebook") {
			return signInWithRedirect(auth, FaceBookProvider);
		} else if (provider === "github") {
			return signInWithRedirect(auth, GithubProvider);
		}
	};

	const SIGN_UP_WITH_EMAIL = (email, password) => {
		return createUserWithEmailAndPassword(auth, email, password);
	};

	const signout = () => {
		return signOut(auth);
	};

	const changedisplayname = (name) => {
		return updateProfile(auth.currentUser, {
			displayName: name,
		});
	};

	const setpersistence = (persistence) => {
		setPersistence(auth, persistence);
	};


	// for c0dify below.

	const SEND_EMAIL_FOR_VERIFICATION = () => {
		return sendEmailVerification(currentUser)
	}


	useEffect(() => {
		console.log("[AuthContext.jsx] start");
		const unsubscribe = auth.onAuthStateChanged(async (user) => {
			pink("[onAuthStateChanged from AuthContext.jsx]");
			if (user && user !== "none") {
				green("[AuthContext] user found!");
				setCurrentUser(user);
				if (!signupInProgress) {
					if (!userJson) {
						// sending req to 'login_email', the method retrieves data using email and uid and updates login at.
						// does not matter if login is done via email or oauth, same response either way.
						axios.post("/users/login_email",{
							email: user.email,
							uid: user.uid
						},
						{
							headers: {
								Authorization: `Bearer ${await user.getIdToken()}`,
							}
						}
						)
						.then((dbRes) => {
							console.log(dbRes);
							setUserJson(dbRes.data.user);
						})
						.catch((err) => {
							console.error(err);
							setUserJson({});
							toast.error((err.response.data.message) ? `${err.response.data.error} - ${err.response.data.message}` : (err.response.data.error)  || err.code);
						});
					}
				}
			} else {
				red("[AuthContext] no logged in user found.");
				console.log(user);
				setCurrentUser("none");
			}
		});

		return () => unsubscribe();
	}, []);

	const value = {
		author,
		currentUser,
		signupInProgress,
		setSignupInProgress,
		userJson,
		setUserJson,
		GET_USER,
		SET_USER,
		USER_PRESENT,
		USER_LOADING,
		SIGN_IN_WITH_EMAIL,
		signout,
		signinwithpopup,
		signinwithredirect,
		SIGN_UP_WITH_EMAIL,
		changedisplayname,
		setpersistence,

		SEND_EMAIL_FOR_VERIFICATION,
	};

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
